import { ApiRequest } from "./base";

const apiRoute = "products";

const DEFAULT_SIZES = [
	{
		size_text: "Standard",
		size: "standard",
		price: 0,
		stem_count: 6,
		enabled: true,
	},
	{
		size_text: "Medium",
		size: "medium",
		price: 5,
		stem_count: 10,
		enabled: true,
	},
	{
		size_text: "Large",
		size: "large",
		price: 10,
		stem_count: 14,
		enabled: true,
	},
];

const normalizeProductSizes = (product) => {
	if (!product) return product;

	// Apply default sizes if product has sizes enabled but no sizes defined
	if (product.has_sizes && (!product.sizes || product.sizes.length === 0)) {
		product.sizes = DEFAULT_SIZES;
	}

	return product;
};

export const ProductApi = {
	async getInfo(id) {
		const response = await ApiRequest(`${apiRoute}/${id}`, "GET");
		if (response.product) {
			response.product = normalizeProductSizes(response.product);
		}
		return response;
	},
	async getInfoBulk(ids = []) {
		const response = await ApiRequest(`${apiRoute}/batch/${ids.join(",")}`, "GET");
		if (response.products) {
			Object.keys(response.products).forEach((key) => {
				response.products[key] = normalizeProductSizes(response.products[key]);
			});
		}
		return response;
	},
	async getRelated(id) {
		return ApiRequest(`${apiRoute}/suggestions/${id}`, "GET");
	},
	async getDeliveryMethods(id, date) {
		const res = await ApiRequest(`${apiRoute}/${id}/delivery-options`, "POST", {
			date: date,
		});

		return res.delivery_options;
	},
};
